<template>
	<div
		class="configurator-navigation" ref="stickyButtonAnchor">
		<div class="configurator-navigation__wrapper" ref="wrapperHandle">
			<div class="configurator-navigation-sticky-flex-container">
				<div
					class="configurator-navigation__button-container configurator-navigation__button-container--price"
					:class="{'text--center' : loadingPrice}"
					v-if="!isOverviewStep && !isLastUploadStep">
					<div v-if="!loadingPrice" class="configurator-price-holder-wrapper">
						<div class="configurator-price-holder">
							<template v-if="hasPrice && canShowPriceDueToCustomSize">
								<div class="configurator-price-holder__side configurator-price-holder__side--left">
									<price
										class="text--right"
										smaller/>

								</div>
								<div class="configurator-price-holder__side configurator-price-holder__side--divider">
									<div class="configurator-navigation-divider"/>
								</div>
								<div class="configurator-price-holder__side configurator-price-holder__side--right">
									<spine
										navigation
										v-if="configuratorData.hasMultiplePages"/>
									<price-pages
										v-if="!configuratorData.hasMultiplePages"/>
									<price-amount />
								</div>
							</template>
						</div>
					</div>
					<template v-else>
						<div class="loading loading--smaller">
							<div/><div/><div/>
						</div>
					</template>
				</div>

				<div class="configurator-navigation__button-container">
					<button
						class="configurator-navigation__button configurator-navigation__button--previous button button--white"
						v-if="getAvailableSteps.prev && !isLastUploadStep"
						title="Vorige"
						@click="prevStep">
						Vorige</button>

					<button
						class="configurator-navigation__button button"
						v-if="!getAvailableSteps.prev && !isLastUploadStep"
						title="Vorige"
						disabled>
						Vorige</button>

					<a
						class="configurator-navigation__button button button-cta"
						title="Direct ontwerpen" v-if="editorUrl"
						:href="editorUrl">
						Ontwerpen
					</a>

					<button
						class="configurator-navigation__button button button-cta"
						title="Volgende"
						v-if="!isOverviewStep && !isLastUploadStep"
						:class="stepClass"
						:disabled="!getAvailableSteps.next"
						@click="nextStep">
						Volgende
					</button>

					<button
						v-if="!isOffTheShelf && isOverviewStep && !uploadsComplete && !configuratorType.isConfiguration"
						class="configurator-navigation__button button button--indigo"
						title="Uploaden"
						@click="uploadFiles">Bestanden uploaden</button>

					<button
						class="configurator-navigation__button button button--cta button--no-change button--icon-ms-small"
						title="Overzicht"
						v-if="isLastUploadStep && uploadsComplete"
						@click="configuratorOverview">
						Naar overzicht
						<span
							v-show="disableOrderButton"
							class="button-loader loading"/>
					</button>

					<button
						class="configurator-navigation__button button button--cta button--no-change button--icon-ms-small"
						:title="this.orderButtonText()"
						v-if="isOverviewStep"
						@click="addToCart"
						data-loading
						:disabled="disableOrderButton">
						{{ this.orderButtonText() }}
						<span
							v-show="disableOrderButton"
							class="button-loader loading"/>
					</button>
				</div>
			</div>
		</div>
		<modal
			button-style="none"
			modal-style="styled"
			:open="openModal"
			v-if="isConfiguratorDataValid">
			<span
				class="success-message"
				v-if="getOrder.success">
				<svg
					class="checkmark"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 52 52">
					<circle
						class="checkmark__circle"
						cx="26"
						cy="26"
						r="25"
						fill="none"/>
					<path
						class="checkmark__check"
						fill="none"
						d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
				</svg>
				<span class="success-message__text">Toegevoegd aan winkelwagen</span>
				<div class="error-message__holder">
					<p>U wordt doorverwezen...</p>
				</div>
			</span>

			<span
				class="error-message"
				v-if="!getOrder.success">
				<svg
					class="error"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 52 52">
					<circle
						class="error__circle"
						cx="26"
						cy="26"
						r="25"
						fill="none"/>
					<path
						class="error__cross"
						fill="none"
						d="M15 15l22 22 M37 15l-22 22"/>
				</svg>
				<span class="success-message__text">Er ging iets fout...</span>
				<div class="error-message__holder">
					<p v-text="getOrder.message"/>
				</div>
			</span>

			<a
				:href="CONFIG.HOST + 'winkelwagen/'"
				class="button button--cta"
				v-if="getOrder.status">Ga naar winkelwagen</a>
		</modal>
	</div>
</template>

<script>
import modal from "@/components/element/modal";
import {EventBus} from "@/store/index.js";
import price from "@/components/element/price";
import priceAmount from "@/components/element/price-amount";
import pricePages from "@/components/element/price-pages";
import spine from "@/components/element/spine";
import {mapState} from "vuex";
import { Events, pushEvent } from "@/helpers/tracking.js";

export default {
	name: "ConfiguratorNavigationButtons",
	components: {
		modal,
		price,
		spine,
		priceAmount,
		pricePages
	},
	props: {
		name: {
			type: String,
			default: ""
		}
	},
	data () {
		return {
			openModal: false,
			disableOrderButton: false,
			autoScrollDebounce: 0,
			referenceDivContainer: null,
			hasSelectedOrderLineAmount: false
		};
	},
	computed: {
		...mapState(["baseProps"]),
		getOrder () {
			return this.$store.getters.getOrder;
		},
		stepClass () {
			return this.getAvailableSteps.next ? "button--cta" : "button--grey";
		},
		getAllSteps () {
			return this.$store.getters.getAllSteps;
		},
		getCurrentStep () {
			return this.$store.getters.getCurrentStep;
		},
		getNextStep () {
			return this.getAllSteps[this.getCurrentStep.index + 1] || null;
		},
		stepActive () {
			if (this.getCurrentStep.index >= Object.keys(this.getAllSteps).length) {
				return false;
			}
			return this.getAllSteps[this.getCurrentStep.index].name === this.name;
		},
		getAvailableSteps () {
			return this.$store.getters.getStepsAvailability;
		},
		isOffTheShelf () {
			return this.$store.getters.isOffTheShelf;
		},
		isOverviewStep () {
			return this.$store.getters.getCurrentStep.data.name === "configurator-overview";
		},
		isUploadStep () {
			return this.$store.getters.getCurrentStep.data.name === "uploader";
		},
		isPriceTableStep () {
			return this.$store.getters.getCurrentStep.data.name === "price-table";
		},
		uploadsComplete () {
			return this.$store.getters.uploadsAreComplete;
		},
		getPayload () {
			return this.$store.getters.getCalculationPayload;
		},
		configuratorType () {
			return this.$store.getters.getConfiguratorType;
		},
		isConfiguratorDataValid () {
			return this.$store.getters.isConfiguratorDataValid;
		},
		checkData () {
			return this.$store.getters.checkData;
		},
		isLastUploadStep () {
			return this.isConfiguratorDataValid
				&& this.isUploadStep
				&& this.checkData.hasSelectedFormat
				&& this.checkData.hasSelectedOptions;
		},
		configuratorData () {
			return this.$store.getters.getConfiguratorData;
		},
		loadingPrice () {
			return this.$store.getters.getLoader.price;
		},
		hasPrice () {
			return this.$store.getters.getPrice.PriceWithoutTax != null;
		},
		optionGroups () {
			const optionGroups = this.$store.getters.getSelectedFormat.productOptionGroups;
			return optionGroups.sort((a, b) => a.index - b.index);
		},
		unavailableOptions () {
			return this.$store.getters.getUnavailableOptions;
		},
		canShowPriceDueToCustomSize () {
			const isCustomSize = this.$store.getters.getSelectedFormat.isCustomSize;
			const validCustomSize = this.$store.getters.getCustomSizeValid;

			return isCustomSize ? (isCustomSize && validCustomSize) : true;
		},
		getOrderLine () {
			return this.$store.getters.getOrderLine;
		},
		editorUrl () {
			const format = this.$store.getters.getSelectedFormat;

			if (!format || !this.baseProps.specifications) {
				return null;
			}

			const specification = this.baseProps.specifications
				.find(s => s.id === format.id);

			if (!specification) {
				return null;
			}

			return specification.editorUrl;
		}
	},
	methods: {
		stepExists (stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive: function (step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		},
		checkNextStep () {
			if (this.getNextStep.name === "select-format" && this.getCurrentStep.data.name === "uploader") {
				const stepPosition = this.getAllSteps.findIndex(step => step.name === "select-format");
				const secondStep = this.getAllSteps[stepPosition + 1];
				if (secondStep) {
					return secondStep.name;
				}
			}

			return "";
		},
		checkPreviousStep () {
			const allSteps = this.getAllSteps;
			const options = this.optionGroups;
			const stepPosition = allSteps.findIndex(step => step.name === this.getCurrentStep.data.name);
			const unavailableOptions = this.unavailableOptions;

			function checkStepsArray (step) {
				const previousStep = allSteps[step - 1] || null;
				const option = options.filter(option => option.title === previousStep.title)[0] || null;

				if (option && option.directlyVisibleOptions) {
					const visibleOptions = option.directlyVisibleOptions.filter(optionId => !unavailableOptions.includes(optionId));

					if (visibleOptions.length > 1) {
						return option.id;
					}

					return checkStepsArray(step - 1);
				}

				return "";
			}

			return checkStepsArray(stepPosition);
		},
		nextStep () {
			if (window.matchMedia("(max-width: 480px)").matches) {
				document.body.classList.add("fade-in-slower");
			}

			setTimeout(() => {
				document.body.classList.remove("fade-in-slower");
			}, 400);

			if (this.checkNextStep() !== "") {
				this.$store.commit("SET_STEP_ACTIVE", this.checkNextStep());
				return;
			}

			this.$store.commit("CONFIGURATOR_STEP_NEXT");
		},
		prevStep () {
			if (window.matchMedia("(max-width: 480px)").matches) {
				document.body.classList.add("fade-in-slower");
			}

			setTimeout(() => {
				document.body.classList.remove("fade-in-slower");
			}, 400);

			if (this.checkPreviousStep() !== "") {
				this.$store.commit("SET_STEP_ACTIVE", this.checkPreviousStep());
				return;
			}

			this.$store.commit("CONFIGURATOR_STEP_PREV");
		},
		async uploadFiles () {
			try {
				await this.$store.dispatch("_createConfiguration");
				await this.$store.dispatch("_saveConfiguration");
			} catch (error) {
				console.error("Failed to prepare configuration before upload step", error);
			}
			this.setStepActive("uploader");
		},
		async configuratorOverview () {
			this.setStepActive("configurator-overview");
			this.$forceUpdate();
			await this.$nextTick();
			this.$forceUpdate();
		},
		addToCart () {
			const selectedProduct = this.$store.getters.getSelectedProduct;
			const selectedFormat = this.$store.getters.getSelectedFormat;
			const price = this.$store.getters.getPrice;
			const orderLine = this.getOrderLine;

			pushEvent(Events.ADD_TO_CART, {
				productName: selectedProduct ? selectedProduct.name : null,
				formatName: selectedFormat ? selectedFormat.name : null,
				amount: orderLine ? orderLine.amount : null,
				price: price ? price.PriceWithoutTax : null
			});

			this.$store.dispatch("_postConfiguration");
			this.disableOrderButton = true;
		},
		scrollToStep () {
			const stepName = this.$store.getters.getCurrentStep.data.name;
			if (stepName && document.querySelector(`#${stepName}`)) {
				setTimeout(() => {
					const stepElement = document.querySelector(`#${stepName}`);
					const ctaHolder = stepElement.querySelector(".configurator-navigation");
					const header = document.querySelector(".header");
					const newScrollPos = this.calculateScrollPos(header, stepElement, ctaHolder);
					window.scrollTo({
						top: Math.abs(newScrollPos),
						behavior: "instant"
					});
				}, 0);
			}
		},
		calculateScrollPos (navHeader, stepperHeader) {
			const viewportHeight = window.innerHeight;

			const headerRect = stepperHeader.getBoundingClientRect();
			const navHeaderRect = navHeader.getBoundingClientRect();

			const effectiveViewportTop = navHeaderRect.height;
			const effectiveViewportHeight = viewportHeight - effectiveViewportTop;

			const headerVisible = (
				headerRect.top >= effectiveViewportTop
				&& headerRect.bottom <= viewportHeight
			);

			if (headerVisible) {
				return window.pageYOffset;
			}

			const combinedCurrentHeaderAndContent = headerRect.top;
			const canFitCurrentHeaderAndContent = combinedCurrentHeaderAndContent <= effectiveViewportHeight;

			if (canFitCurrentHeaderAndContent) {
				const currentScroll = window.pageYOffset;
				const targetScroll = currentScroll + viewportHeight;

				const headerTopAfterScroll = headerRect.top - (targetScroll - currentScroll);
				if (headerTopAfterScroll < effectiveViewportTop) {
					return currentScroll + (headerRect.top - effectiveViewportTop);
				}
				return targetScroll;
			}

			return window.pageYOffset + (headerRect.top - effectiveViewportTop);
		},
		orderButtonText () {
			if (this.configuratorType.isConfiguration
				&& !this.baseProps.isSpecificationConfiguration
				&& !this.baseProps.specificationId) {
				return "Opslaan & bestellen";
			}

			return "Bestellen";
		},
		stickyCheck () {
			if (!this.stepActive || !this.getAvailableSteps.next || !this.referenceDivContainer) {
				return;
			}

			if (this.getCurrentStep.data.name === "price-table" && !this.hasSelectedOrderLineAmount) {
				return;
			}

			const targetRect = this.$refs.stickyButtonAnchor.getBoundingClientRect();
			const shouldUnstick = window.innerHeight >= targetRect.bottom;

			if (shouldUnstick) {
				this.$refs.wrapperHandle.classList.remove("configurator-navigation__wrapper--sticky");
			} else {
				this.$refs.wrapperHandle.classList.add("configurator-navigation__wrapper--sticky");
			}

			const containerRect = this.referenceDivContainer.getBoundingClientRect();
			this.$el.style.setProperty("--configurator-sticky-left", `${containerRect.left}px`);
			this.$el.style.setProperty("--configurator-sticky-width", `${containerRect.width}px`);
		}
	},
	watch: {
		getOrder: (a, b) => {
			EventBus.$emit("openModal");
		},
		"getOrder.success": function (isUnsuccessful) {
			if (isUnsuccessful) {
				this.disableOrderButton = false;
			}
		},
		"getCurrentStep.data.name": function () {
			clearTimeout(this.autoScrollDebounce);
			this.autoScrollDebounce = setTimeout(() => this.scrollToStep(), 100);
		},
		"getAvailableSteps.next": function () {
			this.stickyCheck();
		},
		"getOrderLine.amount": function (cur, prev) {
			if (prev === 0) {
				return;
			}
			this.hasSelectedOrderLineAmount = true;
			this.stickyCheck();
		}
	},
	mounted () {
		EventBus.$on("openModal", () => {
			this.openModal = false;
			setTimeout(
				function () {
					this.openModal = true;
				}.bind(this),
				100
			);
		});
		this.referenceDivContainer = this.$el.closest(".configurator-step");
		addEventListener("scroll", this.stickyCheck, {passive: true});
		addEventListener("resize", this.stickyCheck, {passive: true});
		document.addEventListener("orderConfiguration", this.addToCart);
	},
	beforeDestroy () {
		removeEventListener("scroll", this.stickyCheck);
		removeEventListener("resize", this.stickyCheck);
	}
};
</script>

<style lang="scss" scope="global">
.button--icon-small {
  padding: 8px 40px 8px 18px !important;
  font-size: 1.5rem !important;
  line-height: 1.7rem !important;

  .icon--button {
    width: 24px;
    height: 23px;
    padding: 5px;
    right: 8px;
    top: 5px;
  }
}

.configurator-price-holder {
	display: grid;
	grid-template-columns: 1fr 2px 1fr;
	gap: 16px;
}

.configurator-price-holder__side {
	display: flex;
	justify-content: center;

	&--left {
		justify-content: flex-end;
	}

	&--right {
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}
}

.configurator-navigation-divider {
  height: 100%;
  background: #ccc;
  display: block;
  width: 2px;
}

.configurator-additional-info {
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 1.8rem;
}

.configurator-navigation__wrapper {
	display: flex;
	flex-direction: column;
	margin: 15px 0 10px;
	padding: 15px 0px;
	gap: 24px;
}

.configurator-navigation-sticky-flex-container {
	position: relative;
	display: contents;
}

.configurator-navigation__wrapper--sticky {
	position: fixed;
	width: 100%;
	margin: 15px 0 0;
	bottom: 0;
	left: 0;
	z-index: 1;
	background-color: #fff;
	box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
}

.configurator-navigation__wrapper--sticky .configurator-navigation-sticky-flex-container {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: var(--configurator-sticky-width);
	left: var(--configurator-sticky-left);
}

.configurator-navigation {
	min-height: 136px;
}

.configurator-navigation__button-container {
	display: flex;
	flex-wrap: wrap-reverse;
	justify-content: center;
	align-items: center;
	gap: 12px;

	min-height: 40px;
}

.configurator-navigation__button {
	border-width: 2px !important;
	min-width: 200px;
}

.configurator-navigation__button--previous {
	border-color: var(--cfg-primary-border) !important;
}

.configurator-navigation__button,
.configurator-navigation__button:after {
  transition: background 0.2s ease;
}

.loading {
  margin: 21px 0;
  display: inline-block;
  text-align: left;

  & > div {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background-color: var(--cfg-primary-dark);
    border-radius: 100%;
    vertical-align: middle;
    // -webkit-animation: pulse 1.2s infinite ease-in-out;
    animation: pulse 0.8s infinite ease-in-out;

    &:nth-child(1),
    &:nth-child(3) {
      animation-delay: -0.2s;
      width: 12px;
      height: 12px;
      opacity: 0.6;
    }
  }

  &--smaller,
  &--table {
    margin: 2px 0;
  }

  &--table {
    text-align: center;
    width: 100%;

    & > div {
      width: 15px;
      height: 15px;

      &:nth-child(1),
      &:nth-child(3) {
        width: 8px;
        height: 8px;
  }
    }
  }
}
.table__row--custom-active .loading > div,
.table__data--active .loading > div {
    background-color: #fff;
}

@media screen and (max-width: 600px) {
	.configurator-navigation {
		padding: 0;
	}

	.loading {
		margin: 20px 0 16px;

		&--table {
			margin: 9px 0 8px;
		}
		&--smaller {
			margin: 2px 0;
		}
	}

	.configurator-navigation__wrapper--sticky .configurator-navigation-sticky-flex-container, .configurator-navigation__wrapper {
		gap: 14px;
	}
}
@media screen and (max-width: 480px) {
  .configurator-navigation__button-container {
    min-height: 53px;
  }
}

@media screen and (max-width: 445px) {
	.configurator-navigation {
		min-height: 177px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/configurator-navigation-buttons.vue